import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Box from '../components/Box.jsx';

export default function SoundboardAnimal() {
  return (
    <div className='page-content-soundboard'> 
    
    <Container>
      <Row className="g-4 pt-4">
        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Fish'} 
        imageAlt={'Fish'} 
        imageStatic={'./images/fish-static.png'} 
        imageGif={'./images/fish-gif.gif'}
        audioVoice={'/audio/fish.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Bird'}
        imageAlt={'Bird'} 
        imageStatic={'./images/bird-static.png'} 
        imageGif={'./images/bird-gif.gif'}
        audioVoice={'/audio/bird.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Butterfly'}
        imageAlt={'Butterfly'} 
        imageStatic={'./images/butterfly-static.png'} 
        imageGif={'./images/butterfly-gif.gif'}
        audioVoice={'/audio/butterfly.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Frog'}
        imageAlt={'Frog'} 
        imageStatic={'./images/frog-static.png'} 
        imageGif={'./images/frog-gif.gif'}
        audioVoice={'/audio/frog.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Monkey'}
        imageAlt={'Monkey'} 
        imageStatic={'./images/monkey-static.png'} 
        imageGif={'./images/monkey-gif.gif'}
        audioVoice={'/audio/monkey.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Dog'} 
        imageAlt={'Dog'} 
        imageStatic={'./images/dog-static.png'} 
        imageGif={'./images/dog-gif.gif'}
        audioVoice={'/audio/dog.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Penguin'} 
        imageAlt={'Penguin'} 
        imageStatic={'./images/penguin-static.png'} 
        imageGif={'./images/penguin-gif.gif'}
        audioVoice={'/audio/penguin.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Rabbit'} 
        imageAlt={'Rabbit'} 
        imageStatic={'./images/rabbit-static.png'} 
        imageGif={'./images/rabbit-gif.gif'}
        audioVoice={'/audio/rabbit.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Snake'} 
        imageAlt={'Snake'} 
        imageStatic={'./images/snake-static.png'} 
        imageGif={'./images/snake-gif.gif'}
        audioVoice={'/audio/snake.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Pig'} 
        imageAlt={'Pig'} 
        imageStatic={'./images/pig-static.png'} 
        imageGif={'./images/pig-gif.gif'}
        audioVoice={'/audio/pig.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Squirrel'} 
        imageAlt={'Squirrel'} 
        imageStatic={'./images/squirrel-static.png'} 
        imageGif={'./images/squirrel-gif.gif'}
        audioVoice={'/audio/squirrel.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Bee'} 
        imageAlt={'Bee'} 
        imageStatic={'./images/bee-static.png'} 
        imageGif={'./images/bee-gif.gif'}
        audioVoice={'/audio/bee.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Camel'} 
        imageAlt={'Camel'} 
        imageStatic={'./images/camel-static.png'} 
        imageGif={'./images/camel-gif.gif'}
        audioVoice={'/audio/camel.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Cow'} 
        imageAlt={'Cow'} 
        imageStatic={'./images/cow-static.png'} 
        imageGif={'./images/cow-gif.gif'}
        audioVoice={'/audio/cow.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Elephant'} 
        imageAlt={'Elephant'} 
        imageStatic={'./images/elephant-static.png'} 
        imageGif={'./images/elephant-gif.gif'}
        audioVoice={'/audio/elephant.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Lion'} 
        imageAlt={'Lion'} 
        imageStatic={'./images/lion-static.png'} 
        imageGif={'./images/lion-gif.gif'}
        audioVoice={'/audio/lion.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Dolphin'} 
        imageAlt={'Dolphin'} 
        imageStatic={'./images/dolphin-static.png'} 
        imageGif={'./images/dolphin-gif.gif'}
        audioVoice={'/audio/dolphin.mp3'}/>
        </Col>

        <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center">
        <Box 
        title={'Cat'} 
        imageAlt={'Cat'} 
        imageStatic={'./images/cat-static.png'} 
        imageGif={'./images/cat-gif.gif'}
        audioVoice={'/audio/cat.mp3'}/>
        </Col>
      </Row>
      
      
    </Container>

    </div>
  )
}
